import Joi from "@hapi/joi";

export const userSchema = Joi.object({
  id: Joi.string(),
  name: Joi.string().required().min(6).max(100).regex(/^[a-zA-Z, ]*$/, 'Alphanumerics, space and comma characters'),
  email: Joi.string()
    .required()
    //.email({ minDomainSegments: 2, tlds: { allow: ["com", "net"] } })
    .max(100),
  user_role: Joi.string().required(),
  templates: Joi.array().min(1).required(),
  user_group: Joi.array().min(1).required(),
  web_portal_access: Joi.boolean(),
  web_map_access: Joi.boolean(),
  edotco_site_access: Joi.boolean(),
  operator_site_access: Joi.boolean(),
});
